import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { useMessageBus } from "@jti/fe-message-bus";
import { BreadcrumbItem } from "./BreadcrumbItem/BreadcrumbItem";
import styles from "./Breadcrumbs.module.scss";
export const Breadcrumbs = ({ list, className, isAutomaticallyExpanded = false, useHeadingTag }) => {
    const messageBus = useMessageBus();
    const [lastBreadcrumbTitle, setLastBreadcrumbTitle] = useState(list.at(-1)?.title || "");
    const [isExpanded, setExpanded] = useState(isAutomaticallyExpanded);
    useEffect(() => {
        messageBus.subscribe({
            channel: "update.breadcrumb.name",
            callback: (data) => {
                setLastBreadcrumbTitle(data.payload.breadcrumbName);
            },
        });
    }, [messageBus]);
    if (list.length <= 1)
        return null;
    return (_jsxs("ul", { className: classNames(styles.listContainer, className), children: [!isExpanded && (_jsx("li", { children: _jsxs("button", { "aria-hidden": "true", "data-testid": "breadcrumbsDots", className: styles.dots, onClick: () => setExpanded(true), children: [_jsx("div", { className: styles.dot }), _jsx("div", { className: styles.dot }), _jsx("div", { className: styles.dot })] }) })), list.map((breadcrumb, index) => {
                return (_jsx(BreadcrumbItem, { title: index === list.length - 1 ? lastBreadcrumbTitle : breadcrumb.title, url: breadcrumb.url, isHidden: !isExpanded && index < list.length - 1, hasPrev: index > 0, tag: useHeadingTag && index === list.length - 1 ? "h1" : "span" }, index));
            })] }));
};
//# sourceMappingURL=Breadcrumbs.js.map